module.exports = __webpack_public_path__ + "static/media/jauharabad.2d1904f8.svg";